var $23a41be500b56b00$exports = {};
$23a41be500b56b00$exports = {
    "decrease": (args)=>`Minska ${args.fieldLabel}`,
    "increase": (args)=>`\xd6ka ${args.fieldLabel}`,
    "numberField": `Nummerf\xe4lt`
};


export {$23a41be500b56b00$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
